import { css } from 'lit';
import componentStyles from '../styles/component.styles';
import blockStyles from '../styles/block.styles';
export default css `
  ${componentStyles}
  ${blockStyles}
/**
--------------------------------------------------
* General
--------------------------------------------------
*/
:host {
    --bg: #fff;
    container-type: inline-size;
  }

  .video-item {
    position: relative;
    border-radius: var(--p-video-item-radius, 5px);
    max-width: 100vw;
  }

  .thumbnail-link {
    display: block;
    color: currentColor;
    text-decoration: none;
  }

  .video-item .thumbnail-link:hover .thumbnail img {
    transform: scale(1.05);
  }
  @media (prefers-reduced-motion) {
    .video-item .thumbnail-link:hover .thumbnail img {
      transform: none;
    }
  }

  .video-item .thumbnail-link:hover .thumbnail .play,
  .video-item .thumbnail-link:focus-within .thumbnail .play {
    transform: scale(1);
    opacity: 1;
  }

  .video-item.layout-default .thumbnail-link:hover .title,
  .video-item.layout-default .thumbnail-link:focus-within .title,
  .video-item.layout-full .thumbnail-link:hover .title,
  .video-item.layout-full .thumbnail-link:focus-within .title {
    text-decoration: var(--p-link-text-decoration-hover);
    color: var(--p-link-text-color-hover);
  }

  .text-container {
    padding: 0 0.3rem;
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
  }

  .thumbnail {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    aspect-ratio: 16/9;
    border-radius: var(--p-video-item-radius, 5px);
    margin-bottom: 0.8rem;
  }

  .thumbnail img {
    width: 100%;
    height: 100%;
    position: absolute;
    object-fit: cover;
    transform: translateZ(0);
    will-change: transform;
    transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  }
  @media (prefers-reduced-motion) {
    .thumbnail img {
      transition: none;
    }
  }

  .play {
    position: relative;
    opacity: 0;
    width: 30px;
    height: 30px;
    transform: scale(0.9) translateZ(0);
    will-change: transform;
    transition:
      transform 350ms cubic-bezier(0.175, 0.885, 0.385, 1.85),
      opacity 200ms;
  }
  @media (prefers-reduced-motion) {
    .play {
      transition: none;
    }
  }

  .meta {
    opacity: var(--p-text-meta-opacity);
    font-size: var(--p-font-size-small);
  }

  .live-badge {
    position: absolute;
    left: 5px;
    top: 5px;
  }

  .title {
    display: block;
    font-family: var(--p-h6-font);
    font-size: var(--p-h6-font-size);
    font-weight: var(--p-h6-font-weight);
    font-style: var(--p-h6-font-style);
    line-height: 1.2;
    text-transform: var(--p-h6-transform);
    letter-spacing: var(--p-h6-letter-spacing);
    margin: 0;
    color: var(--p-link-text-color);
    text-decoration: var(--p-link-text-decoration);
  }

  .published,
  .description {
    display: inline-block;
    line-height: 1.4;
    font-size: var(--p-font-size-small);
  }

  .description {
    font-size: 0.875rem;
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  /**
--------------------------------------------------
* Upcoming
--------------------------------------------------
*/
  .upcoming .upcoming-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.65);
    padding: 0 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--p-text-color-light);
    text-align: center;
    line-height: 1.4;
  }

  .upcoming .upcoming-badge {
    position: absolute;
    left: 5px;
    top: 5px;
  }

  /**
--------------------------------------------------
* Layouts
--------------------------------------------------
*/
  .layout-card,
  .layout-portrait {
    overflow: hidden;

    .description {
      display: none;
    }

    .text-container {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 1rem;
      color: var(--p-text-color-light);
      z-index: 1;
    }

    .thumbnail {
      margin-bottom: 0;
    }

    .thumbnail::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 50%;
      background: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.9) 0%,
        rgba(0, 0, 0, 0.7) 50%,
        transparent 100%
      );
    }

    .title {
      color: var(--p-text-color-light);
      text-decoration: none;
    }
  }

  .layout-card {
    .play {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 20px;
      height: 20px;
    }
    .upcoming-date {
      display: none;
    }
  }

  .layout-portrait {
    border-radius: var(--p-video-item-portrait-radius, 10px);
    .upcoming-badge,
    .live-badge {
      top: 0.5rem;
      left: 0.5rem;
    }
    .thumbnail {
      aspect-ratio: var(--p-video-item-portrait-aspect-ratio, 300/450);
      border-radius: var(--p-video-item-portrait-radius, 10px);
    }
  }

  .layout-full {
    .thumbnail {
      aspect-ratio: 16/9;
    }
  }

  @container (min-width: 600px) {
    .layout-full {
      .thumbnail-link {
        display: grid;
        grid-template-columns: 40% 1fr;
        align-items: center;
        gap: var(--p-gap);
      }

      .text-container {
        min-width: 0;
        padding-right: var(--p-gap);

        .title {
          font-family: var(--p-h4-font);
          font-size: var(--p-h4-font-size);
          font-weight: var(--p-h4-font-weight);
          font-style: var(--p-h4-font-style);
          line-height: var(--p-h4-line-height);
          text-transform: var(--p-h4-transform);
          letter-spacing: var(--p-h4-letter-spacing);
        }

        .description {
          font-family: var(--p-font);
          line-height: var(--p-body-line-height);
          font-style: var(--p-body-font-style);
          font-size: var(--p-body-font-size);
          font-weight: var(--p-body-font-weight);
          letter-spacing: var(--p-body-letter-spacing);
        }
      }
    }
  }

  /**
--------------------------------------------------
* Type banner
--------------------------------------------------
*/
  :host([type='banner']) {
    display: contents;
  }

  .banner {
    display: contents;
  }

  .banner .thumbnail-link {
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
  }

  .banner .thumbnail {
    aspect-ratio: 16/9;
    min-width: 120px;
    margin: 0;
  }
  .banner .text-container {
    padding: 0;
    flex-grow: 1;
    max-width: 530px;
  }

  .banner .description {
    font-size: 0.875rem;
    margin: 0.3rem 0 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    opacity: var(--p-text-meta-opacity);
  }

  .banner .play {
    width: 20px;
    height: 20px;
  }

  /**
--------------------------------------------------
* Preview
--------------------------------------------------
*/
  .preview {
    width: 100%;
    height: 100%;
  }

  :host([preview]) .preview {
    background-color: rgba(0, 0, 0, 0.1);
  }

  :host([dark][preview]) .preview {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;
